// Activity categories shown in the WZT list/timeline view. Each maps to one of
// the three collections returned by GET /api/hours/employee-activities. The
// colors mirror EmployeeProjectsSidebar.vue so the two views stay consistent.
export const ACTIVITY_CATEGORY_OPTIONS = [
  { value: 'ziekte', label: 'Ziekte' },
  { value: 'verlof', label: 'Verlof' },
  { value: 'performance_expertise', label: 'Performance & expertise' },
  { value: 'projects', label: 'Projecten' },
  { value: 'presourcings', label: 'Pre-sourcings' },
  { value: 'voorstellen', label: 'Voorstellen' }
]

// Default: show everything.
export const DEFAULT_ACTIVITY_CATEGORIES = [
  'ziekte',
  'verlof',
  'performance_expertise',
  'projects',
  'presourcings',
  'voorstellen'
]
